import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as organizationOffering from '../../organization-offering'

export const RESOURCE = {
  payload: {
    description:
      'The association(s) between organizational units and offerings',
    dimension: organizationOffering.RESOURCE.payload,
    level: 0,
    name: 'Organization Offering',
    partialId: PartialId.Standard.create('entry'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
